import React from 'react';
import type { InputHTMLAttributes } from 'react';

export interface DatePickerProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  error?: string;
  required?: boolean;
}

export function DatePicker({
  label,
  error,
  required,
  id,
  ...rest
}: DatePickerProps): React.ReactElement {
  const inputId = id ?? `date-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={`input-group${error ? ' input-group--error' : ''}`}>
      <label htmlFor={inputId} className="input-group__label">
        {label}
        {required && <span className="input-group__required" aria-hidden="true">*</span>}
      </label>
      <input
        type="date"
        id={inputId}
        className="input-group__input"
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        required={required}
        {...rest}
      />
      {error && (
        <span id={`${inputId}-error`} className="input-group__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
